import { TimeFrame } from './TimeFrame';
export class TimeFrameManager{
	

	timeframes : Array< Array<TimeFrame> >;
	
	// timeframes der woche für eine zone.
	constructor(){
		this.timeframes = new Array<Array<TimeFrame>>();
		for(let i=0;i<7;i++){
			this.timeframes.push(new Array<TimeFrame>());
		}
	}
	bucket:string;
	setBucket(b:string){
		this.bucket=b;
	}
	getBucket(){
		return this.bucket;
	}
	getCurrentValue(){
		return this.getCurrentTimeFrame().getValue();
	}
	clearDay(day:number){
		if(day >= 0 && day <7){
			this.timeframes[day].length=0;
		}
	}

	patch(id : number, frame : TimeFrame){
		let idx =-1;
		let pos = 0;
		for(let timeframe of this.timeframes[frame.getDay()]){
			if(timeframe.getId() == id){
				idx = pos;
			}
			pos++;
		}
		if(idx != -1){
			this.timeframes[frame.getDay()].splice(idx,1);
		}
		frame.setId(id);
		this.timeframes[frame.getDay()].push(frame);
	}
	getCurrentTimeFrame(){
		let now = new Date();
		let day = now.getDay();
		let tf = this.getTimeFrame(day,now);
		return tf;
	}
	addTimeFrame(frame:TimeFrame){
		let tf = new TimeFrame();
		tf.copy(frame);
		this.timeframes[frame.day].push(tf);

		this.debug("Adding timeframe: "+tf.toString()+ " to day "+frame.day+ " length now: "+this.timeframes[frame.day].length);
	}
	toString(debug?:boolean){
		let str=  "\n<--\n";
		for(let day of [0,1,2,3,4,5,6]){
			str+= " - day:"+day+"\n";
			for(let frame of this.getTimeFrames(day)){
				str+= " -- "+frame.toString(true)+"\n";
			}
		}
		return str+"-->\n";
	}
	addTimeFrameByArgs(day:number, begin:Date, end:Date, value:number,bucket?:string,ignoreTemperature?:boolean) : boolean{
		// für jeden tag der woche
		if(day >= 0 && day < 7){
			let timeframe = new TimeFrame();
			timeframe.setDay(day);
			timeframe.setBegin(new Date(begin.getTime()));
			timeframe.setEnd(new Date(end.getTime()));
			timeframe.setValue(value);
			timeframe.setIgnoreTemperature(ignoreTemperature);
			if(bucket){
				timeframe.setBucket(bucket);
			}
			for(let tf of this.timeframes[day]){
				if(tf.overlapsWith(timeframe)){
					this.debug("::addTimeFrame(): new frame overlaps with existing element. Aborting.");
					return false;
				}
			}
			this.debug("Adding timeframe: "+timeframe.toString()+ " to day "+timeframe.day+ " length now: "+this.timeframes[timeframe.day].length);
			this.timeframes[day].push(timeframe);
			return true;
		}else{
			this.debug("addTimeFrame(): argument-constraint: 0 < day < 7")
		}
	}
	forDay(day){
		return this.timeframes[day];
	}
	getAllTimeFrames(): Array< Array<TimeFrame> >{
		return this.timeframes;
	}
	removeTimeFrame(day:number, date: Date):void{
		let removals = new Array<TimeFrame>();
		if(day >= 0 && day < 7){
			for(let timeframe of this.timeframes[day]){
				if(timeframe.contains(date)){
					removals.push(timeframe);
				}
			}
			for(let timeframe of removals){
				let pos = this.timeframes[day].indexOf(timeframe);
				if(pos != null){
					this.timeframes[day].splice(pos,1);
				}
			}

		}else{
			this.debug("removeTimeFrames(): argument-constraint: 0 < day < 7");
		}

	}

	removeTimeFrames(day:number):void{
		if(day >= 0 && day < 7){
			this.timeframes[day].length = 0;
		}else{
			this.debug("removeTimeFrames(): argument-constraint: 0 < day < 7");
		}

	}
	getMostRecentFrame(day:number){
		if(this.timeframes[day].length >0){
			return this.timeframes[day][this.timeframes[day].length -1];
		}else{
			this.debug("Was asked for latest timeframe on day "+day+ " but timeframes are empty.");
			return null;
		}
	}
	getTimeFrame(day:number, date : Date):TimeFrame|null{
		
		for(let timeframe of this.timeframes[day]){
			if(timeframe.contains(date)){
				return timeframe;
			}
		}
		return null;
	}
	getTimeFrames(day:number) : Array<TimeFrame>|null{
		if(day >= 0 && day < 7){
			return this.timeframes[day];
		}else{
			this.debug("getTimeFrames(): argument-constraint: 0 < day < 7");
			return null;
		}
	}
	_debug:boolean=false;
	debug(msg:string):void{
		if(this._debug){
		console.log("TimeFrameManager: "+msg);
		}
	}
}